import { FC, useEffect } from 'react';
import BottomSheet from './bottom-sheet';
import useLinhaTempoStore from './store';
import LinhaTempoMap from './map';
import useAsyncFetch from '../../hooks/use-async';

const LinhaTempo: FC = () => {
  const fetchItens = useLinhaTempoStore((state) => state.fetchItens);
  const clearStore = useLinhaTempoStore((state) => state.clear);

  useAsyncFetch(
    {
      callback: fetchItens,
      errorMessage: 'Falha ao carregar a linha do tempo.',
      withLoader: true,
    },
    [],
  );

  useEffect(() => {
    const cleanup = () => {
      clearStore();
    };

    return cleanup;
  }, [clearStore]);

  return (
    <div className="linha-tempo flex flex-column h-full">
      <LinhaTempoMap />
      <BottomSheet />
    </div>
  );
};

export default LinhaTempo;
